/** @jsxImportSource @emotion/react */
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import tw, { styled } from 'twin.macro';
import useLocalization from '../../hooks/useLocalization';


const DropDown = ({ label, value, list, handleChange }) => {

  const { lang } = useLocalization();

  return(
    <DropDownWrapper>
      <FormControl fullWidth size="small">
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          label={label}
          onChange={handleChange}
        >
          {Object.keys(list).map((key,index) => <MenuItem value={key} key={`option_${key}`}>{list[key].label[lang]}</MenuItem>)}
        </Select>
      </FormControl>
    </DropDownWrapper>)
}

export default DropDown;

const DropDownWrapper = styled.div`
  ${tw`
    w-[150px]
  `}
`